import {
  Component,
  Input,
  forwardRef,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl, Validator } from '@angular/forms';
import { BllSelectComponent } from '../select';
import { Subject } from 'rxjs';

@Component({
  selector: 'bll-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'leumi-bll-autocomplete',
    role: 'button',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => BllAutocompleteComponent), multi: true }],
})
export class BllAutocompleteComponent extends BllSelectComponent implements ControlValueAccessor {
  @Input() minTermLength: number = 0;
  @Input() loading: boolean = false;
  @Input() typeahead: Subject<any>;
  @Input() notFoundText: string = 'לא נמצאו תוצאות'; //TODO: translate
  @Input() loadingText: string = 'טוען..'; //TODO: translate
  @Input() typeToSearchText: string = 'הקלד כדי להתחיל חיפוש'; //TODO: translate
  @Input() extraLabels: Array<any> | null = null;
  protected _searchable: boolean = true;
  protected _clearable: boolean = true;
  constructor(public _changeDetectorRef: ChangeDetectorRef) {
    super(_changeDetectorRef);
  }
}
